export default __webpack_public_path__ + "static/media/gradle-setup.c13979b7.md";